import { useParams } from "react-router-dom";
import { useSessionStorage } from "usehooks-ts";

export const useBuildNumber = () => {
	const { game } = useParams();
	return useSessionStorage<number | null>(`${game}-build`, null);
};
